import { CHANGE_SIGNALR_CONNECTION_STATE } from '../constants/SignalR'

export const changeSignalRConnection = (status) => {
    return {
        type: CHANGE_SIGNALR_CONNECTION_STATE,
        status
    }
}